import cls from 'classnames';
import React, { FC } from 'react';

import CustomLink from '@/components/custom-link';
import Image from '@/components/image';
import { ImageSectionEntry } from '@/types/views/sections';

import styles from './styles';

const ImageSection: FC<ImageSectionEntry> = ({
  image,
  link,
  layout,
  imageMobile,
  deactivateAdSlots,
}) => {
  const ImageElement = () => (
    <>
      {imageMobile && (
        <Image
          className={image ? 'md:hidden' : undefined}
          src={imageMobile.src}
          fallbackSrc={imageMobile.fallbackSrc}
          useIntrinsicSize
          width={imageMobile.width}
          height={imageMobile.height}
          basicLoader={imageMobile.isExternal}
        />
      )}

      {image && (
        <Image
          className={imageMobile ? 'hidden md:block' : undefined}
          src={image.src}
          fallbackSrc={image.fallbackSrc}
          useIntrinsicSize
          width={image.width}
          height={image.height}
          basicLoader={image.isExternal}
        />
      )}
    </>
  );

  const ImageComponent = () => (
    <>
      {link ? (
        <CustomLink className="inline-block" {...link}>
          <ImageElement />
        </CustomLink>
      ) : (
        <ImageElement />
      )}
    </>
  );

  return (
    <div className={styles.wrapper}>
      <div
        className={cls(
          'content-box text-center leading-none',
          deactivateAdSlots && 'ml-auto',
        )}
      >
        {layout === 'rich-text' ? (
          <div className="text-box">
            <ImageComponent />
          </div>
        ) : (
          <ImageComponent />
        )}
      </div>
    </div>
  );
};

export default ImageSection;
